module.exports = __webpack_public_path__ + "img/xeno-6.7340a32f.jpg";